<template>
  <div class="container">
    <b-modal
      :model-value="modAsociaDesasociaRol"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      size="xl"
      dialog-class="modal-roles-wide"
      :title="infoMenu[0]?.nombre"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
        <div class="uniform-modal-body uniform-modal-body--wide">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-item">{{ labels.infoText }}</div>
            </div>
            <div class="roles-modal-body">
            <b-row v-for="rol in listRoles" :key="rol.id" class="role-row align-items-center"> 
                <b-col cols="8" class="text-left role-name">{{ rol?.nombre }}</b-col>
                <b-col cols="4" class="text-right">
                    <b-form-checkbox
                      v-model="rolSelected"
                      :value="rol?.id"
                      switch
                      class="mb-0"
                    >
                      {{ isRoleSelected(rol?.id) ? labels.active : labels.inactive }}
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <!-- {{ rolSelected }} -->
            </div>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import Roles from '../../../services/Roles'; 

export default {
    name:"AsociaDesasociaRol",
    props:['modAsociaDesasociaRol','infoMenu'],
    data: () => ({
        rolAsociados : [],
        listRoles : [],
        rolSelected: []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Menu:",
                    save : "Guardar",
                    close : "Cerrar",
                    active: "Activo",
                    inactive: "Inactivo",
                    infoTitle: "Roles del menú",
                    infoText: "Activa o desactiva los roles asociados al menú."
                }
            }else{
                return {
                    title: "Menu:",
                    save : "Save",
                    close : "Close",
                    active: "Active",
                    inactive: "Inactive",
                    infoTitle: "Menu roles",
                    infoText: "Toggle the roles associated with the menu."
                }
            }
        }
    },
    mounted(){

        Roles.getAllRoles() 
        .then((res) => { 
            // console.log(res.data.roles) 
            this.listRoles = res.data.roles 
        })
        .catch((err) => { 
            console.log(err) 
        })
        // this.rolSelected = this.rolAsociados.filter(valor => this.listRoles.some(option => option.id === valor)); 
    },
    methods:{
        isRoleSelected(roleId) {
            return this.rolSelected.includes(roleId)
        },
        cierraModal(){
            // console.log("CierraModal") 
            this.$emit('closeModal',false) 
        },
        guardarMenu(){
            // console.log("guardarMenu") 
            let datos = {
                'idMenu' : this.infoMenu[0].id, 
                'rolesAsociados' : this.rolSelected, 
            }
            // console.log(datos) 

            Menu.updateRolesByMenu(datos) 
            .then((res) => { 
                // console.log(res) 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    location.reload(); 
                }
            })
            .catch((err) =>{console.log(err)}) 
        }
    },
    watch:{
        infoMenu(dataMenu){
            // console.log(dataMenu) 
            let rol = []
            dataMenu.forEach(elem => { 
                // console.log(elem) 
                rol = elem.roles 
            });

            const numbers = [];
            const arrayRol = rol.split(',') 
            arrayRol.forEach(element => numbers.push(Number(element))); 
            
            numbers.forEach(element => { 
                this.rolAsociados.push(element) 
            })
            this.rolSelected = numbers.filter(valor => this.listRoles.some(option => option.id === valor)); 
        }
    }
}
</script>

<style>
.modal-roles-wide .modal-content {
  min-height: 72vh;
}

.roles-modal-body {
  max-height: 65vh;
  overflow-y: auto;
  padding: 0.5rem 0.25rem;
}

.role-row {
  border-bottom: 1px solid #edf1f5;
  padding: 0.45rem 0.2rem;
}

.role-name {
  font-weight: 600;
  color: #2e507a;
}
</style>
